/*
 * Module for Tenants
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/accountAdmin/tenantAdmin/tenantAdminView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/tenantAdmin/tenantAdminModal/tenantAdminModalModule",
  "modules/accountAdmin/tenantAdmin/tenantModel",
  "modules/accountAdmin/landlordAdmin/landlordModel",
], function (
  Marionette,
  Backbone,
  _,
  Messenger,
  TenantAdminView,
  SortableListModule,
  TenantAdminModalModule,
  TenantModel,
  LandlordModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tenantAdmin";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (options) {
      options = options || {};
      const isGlobalAdmin = Messenger.reqres.request("user:is:global:admin");
      const isAdmin = Messenger.reqres.request("user:is:admin");

      this.layout = new TenantAdminView.tenantAdminLayout();

      if (!isGlobalAdmin && isAdmin) {
        // if user is tenant admin, go straight to tenant profile
        this.showTenantAdminView(options);
      } else if (isGlobalAdmin) {
        this.showGlobalAdminView(options);
      }
    },
    showTenantAdminView: function (options) {
      const kbs = Messenger.reqres.request("kbs");
      // TODO Get landlord
      const tenants = new TenantModel.tenants();
      tenants.landlords = new LandlordModel.landlords();

      Messenger.onSave(function () {
        // Set save to true for read-only tenant
        Messenger.saveAttempted(true); //success
      }, this);

      kbs.onSynced(function () {
        const tenantId = Messenger.reqres.request("active:tenantId");
        const tenant = Messenger.reqres.request("fetch:tenant", tenantId);

        tenant.onSynced(function () {
          const landlord = Messenger.reqres.request("fetch:landlord", tenant.get("landlordId"));
          tenants.add(tenant);

          landlord.onSynced(function () {
            tenants.landlords.add(landlord);
            const profileOptions = _.extend({ tenant: tenants.at(0) }, options);
            Messenger.vent.trigger("show:account:admin:tenant:profile", profileOptions);
          }, this);
        }, this);
      }, this);
    },
    showGlobalAdminView: function (options) {
      this.tenants = Messenger.reqres.request("tenants");
      this.tenants.landlords = Messenger.reqres.request("landlords");

      Messenger.onSave(function () {
        if (this.tenant) {
          this.tenant.saveModel();
        } else {
          Messenger.saveAttempted(true); //success
        }
      }, this);

      const headers = Messenger.reqres.request("tenant:admin:headers");

      const extendedEvents = {
        "click .deleteTenant": function () {
          const model = this.model;
          if (model.get("kbUsage") === 0) {
            Messenger.yesNoDialog(
              "admin.tenantAdmin.confirmDeleteTenant",
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Tenant",
                    id: model.id,
                    idType: "Tenant",
                    object: "Tenant",
                  });

                  model.deleteModel();
                },
              },
              this,
            );
          }
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: extendedEvents,
        }),
      );

      //add a new tenant to the list
      this.layout.on("add:tenant", this._addTenant, this);

      this.layout.on(
        "show",
        function () {
          this.list.show(this.tenants);
        },
        this,
      );

      this.tenants.landlords.onSynced(function () {
        this.tenants.onSynced(function () {
          _.each(
            this.tenants.models,
            function (tenant) {
              if (!tenant.get("landlordId")) {
                tenant.landlordName = "None";
              } else {
                tenant.landlordName = this.tenants.landlords
                  .findWhere({
                    landlordId: tenant.get("landlordId"),
                  })
                  .get("landlordName");
              }
            },
            this,
          );
          this.showRegion(this.layout);
          if (options.tenantId) {
            let tenantId = options.tenantId;
            if (tenantId == "new") {
              this._addTenant();
              return;
            }
            tenantId = +tenantId;
            if (tenantId && !isNaN(tenantId)) {
              const tenant = this.tenants.get(tenantId);
              if (tenant) {
                const profileOptions = _.extend({ tenant: tenant }, options);
                Messenger.vent.trigger("show:account:admin:tenant:profile", profileOptions);
                return;
              }
            }
          } else if (options.tenant) {
            Messenger.vent.trigger("show:account:admin:tenant:profile", options);
            return;
          }
          Backbone.history.navigate("accountAdmin/tenants");
        }, this);
      }, this);
    },
    _addTenant: function () {
      const newItem = this.tenants.addItem();
      //show the tenant admin modal
      Messenger.vent.trigger(
        "show:modal",
        TenantAdminModalModule,
        {
          editMode: false,
        },
        newItem,
        {
          title: "admin.tenantAdmin.addTenant",
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: 550,
          trackInteraction: {
            action: "Add Tenant",
            object: "Tenant",
          },
        },
      );
    },
    _setUpVents: function () {
      //Show the tenant admin screen
      Messenger.vent.on(
        "show:account:admin:tenants",
        function (options) {
          this.show(options);
        },
        this,
      );

      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.vent.trigger("show:account:admin:tenant:profile", { tenant: model });
        },
        this,
      );
    },
  });
});
